import vr_headset from "../../assets/vr_headset.png";
import ar_phone from "../../assets/ar_phone.png";
import { FaVrCardboard } from "react-icons/fa6";
import { TbAugmentedReality } from "react-icons/tb";

import "./AboutUsStyle.css";

const AboutUs = ({ t }) => {
  return (
    <div className="aboutUs-container">
      <h2 className="aboutUs-title">{t("about_us")}</h2>
      <p className="aboutUs-subtitle">{t("about_us_subtitle")}</p>
      <div className="vr-ar-section">
        <div className="vr-ar-item">
          <img
            src={vr_headset}
            alt="Virtual Reality Headset"
            className="vr-ar-image"
          />
          <button className="vr-button">
            {t("virtual_reality")}
            <FaVrCardboard size={30} />
          </button>
        </div>
        <div className="vr-ar-item">
          <img
            src={ar_phone}
            alt="Augmented Reality Phone"
            className="vr-ar-image"
          />
          <button className="ar-button">
            {t("augmented_reality")} <TbAugmentedReality size={30} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
